import { MigrationInterface, QueryRunner } from 'typeorm'
import { getRepository } from '@things-factory/shell'
import { Kpi } from '../service/kpi/kpi'

import * as fs from 'fs'
import * as path from 'path'

interface GradeData {
  kpiName: string
  version: number
  description: string
  grades: Array<{
    name: string
    minValue: number
    maxValue: number
    score?: number
    color?: string
    description?: string
  }>
}

export class AddGradesToKpi1752192090123 implements MigrationInterface {
  name = 'AddGradesToKpi1752192090123'

  public async up(queryRunner: QueryRunner): Promise<void> {
    // grade-data 폴더의 JSON 파일들을 읽어서 해당 KPI의 grades 컬럼에 넣기
    await this.loadGradeDataToKpi()
  }

  public async down(queryRunner: QueryRunner): Promise<void> {}

  private async loadGradeDataToKpi(): Promise<void> {
    const gradeDataPath = path.join(__dirname, 'grade-data')
    const kpiRepository = getRepository(Kpi)

    try {
      // grade-data 폴더의 모든 JSON 파일 읽기
      const files = fs.readdirSync(gradeDataPath).filter(file => file.endsWith('.json'))

      for (const file of files) {
        const filePath = path.join(gradeDataPath, file)
        const fileContent = fs.readFileSync(filePath, 'utf8')
        const gradeData: GradeData = JSON.parse(fileContent)

        // KPI 이름으로 해당 KPI 찾기
        const kpi = await kpiRepository.findOne({
          where: { name: gradeData.kpiName, domain: { name: 'SYSTEM' } }
        })

        if (kpi) {
          // grades 데이터를 업데이트
          kpi.grades = gradeData.grades
          await kpiRepository.save(kpi)

          console.log(`✅ Loaded grades for KPI: ${gradeData.kpiName} (${gradeData.grades.length} grades)`)
        } else {
          console.log(`⚠️  KPI not found: ${gradeData.kpiName}`)
        }
      }

      console.log(`🎉 Successfully loaded grades data for ${files.length} files`)
    } catch (error) {
      console.error('❌ Error loading grade data:', error)
      throw error
    }
  }
}
